/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";

const BillingTerritoryDropdown = ({ billing, setBilling, valid }) => {
  const stateArray = [
    "Alberta", // AB
    "British Columbia", // BC
    "Manitoba", // MB
    "New Brunswick", // NB
    "Newfoundland and Labrador", // NL
    "Northwest Territories", // NT
    "Nova Scotia", // NS
    "Nunavut", // NU
    "Ontario", // ON
    "Prince Edward Island", // PE
    "Quebec", //  QC
    "Saskatchewan", // SK
    "Yukon" // YT
  ];

  return (
    <Input
      type="select"
      required
      value={billing.stateName || ""}
      className="custom-dropdown"
      id="billingState"
      onChange={e => {
        setBilling({
          ...billing,
          ...{ stateName: e.target.value }
        });
      }}
      invalid={valid.stateName === false}
    >
      <option value="" hidden>
        Choose
      </option>
      {stateArray.map(state => (
        <option
          className="custom-dropdown-item"
          id={`billingDropdownItem-${state}`}
          key={`state-${state}`}
          onClick={() =>
            setBilling({
              ...billing,
              ...{
                stateName: state
              }
            })
          }
        >
          {state}
        </option>
      ))}
    </Input>
  );
};

BillingTerritoryDropdown.propTypes = {
  billing: PropTypes.shape({
    stateName: PropTypes.string
  }),
  setBilling: PropTypes.func,
  valid: PropTypes.shape({
    stateName: PropTypes.bool
  })
};

BillingTerritoryDropdown.defaultProps = {
  billing: undefined,
  setBilling: undefined,
  valid: undefined
};

export default BillingTerritoryDropdown;
